// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__30fiy","rootSuccess":"CompleteLink_rootSuccess__35_nn","rootFailure":"CompleteLink_rootFailure__1nCRg","isDisabled":"CompleteLink_isDisabled__2RANm"};